import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Autocomplete
} from '@mui/material';

const EditArticleDialog = ({ 
  open, 
  onClose, 
  editForm, 
  setEditForm, 
  onSave 
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Article</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            fullWidth
            value={editForm.title}
            onChange={(e) => setEditForm({ ...editForm, title: e.target.value })}
          />
          <TextField
            label="Topic"
            fullWidth
            value={editForm.topic}
            onChange={(e) => setEditForm({ ...editForm, topic: e.target.value })}
          />
          <TextField
            label="Deployment Path"
            fullWidth
            value={editForm.deployed_path}
            onChange={(e) => setEditForm({ ...editForm, deployed_path: e.target.value })}
            placeholder="e.g., blog/2024/my-article"
            helperText="Relative path where the article will be deployed"
          />
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={editForm.tags}
            onChange={(_, newValue) => setEditForm({ ...editForm, tags: newValue })}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tags"
                placeholder="Add tags"
              />
            )}
          />
          <TextField
            label="Publish Date"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={editForm.publish_date}
            onChange={(e) =>
              setEditForm({ ...editForm, publish_date: e.target.value })
            }
            helperText="Set publish date to schedule the article (optional)"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditArticleDialog; 